export const initHeaderScroll = () => {
    const header = document.querySelector('header');
    const menuBtn = document.getElementById('menu-btn');
    const triggerHeight = window.innerHeight;

    window.addEventListener('scroll', () => {
        if (window.scrollY > triggerHeight) {
            header.classList.add('is-scrolled');
            menuBtn.classList.add('is-scrolled');
        } else {
            header.classList.remove('is-scrolled');
            menuBtn.classList.remove('is-scrolled');
        }
    }); 
};